/**
 * Teammates documentation page — creating, configuring, and managing agent personas.
 */

import { createFileRoute } from "@tanstack/react-router";
import { DocsPage } from "@/components/docs/docs-page";
import { teammatesContent } from "@/constants/docs/teammates";

export const Route = createFileRoute("/docs/teammates")({
	component: TeammatesPage,
});

function TeammatesPage() {
	return <DocsPage title="Teammates" content={teammatesContent} />;
}
